export const getMappedLoadsByHash = (loads) => {
  const mappedLoads = {}
  if (loads && loads.length) {
    loads.map((load) => {
      mappedLoads[load.hashId.replace(/\W/g, '')] = load
      return load
    })
  }
  return mappedLoads
}

export const formatLoadForWaitingDriver = (loads) => {
  if (loads && loads.length) {
    return loads.map(load => (
      {
        ...load,
        statusDelivery: (load.statusDelivery === 'ASSIGNED_TO_TRANSPORTER' && load.driver) ?
          'WAITING_DRIVER_ACCEPT' : load.statusDelivery,
      }
    ))
  }
  return loads
}

export default getMappedLoadsByHash
